"use client";

import React from "react";
import { Sparkles, Feather, Activity, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const methodsData = [{
  id: "hypnosystemisch",
  title: "Hypnosystemischer Ansatz",
  shortDescription: "Nutzen Sie unbewusste Kompetenzen für bewusste, positive Veränderungen in Ihrem Leben.",
  fullDescription: "Der hypnosystemische Ansatz verbindet systemisches Denken mit Konzepten der klinischen Hypnose. Wir fokussieren uns auf Ihre Stärken und Ressourcen, um innere Suchprozesse anzuregen und unbewusste Kompetenzen für bewusste Veränderungen nutzbar zu machen. Dies ermöglicht einen sanften, aber tiefgreifenden Wandel in Krisenzeiten, indem wir den Blick von den Problemen hin zu den bereits in Ihnen angelegten Lösungen lenken.",
  icon: Sparkles
}, {
  id: "achtsamkeit",
  title: "Achtsamkeit",
  shortDescription: "Kommen Sie im Hier und Jetzt an, um innere Ruhe und Klarheit zu finden.",
  fullDescription: "Die Achtsamkeitspraxis hilft Ihnen, aus dem ständigen Gedankenkarussell auszusteigen und im gegenwärtigen Moment anzukommen. Durch gezielte Übungen lernen Sie, Ihre Gedanken und Gefühle ohne Wertung wahrzunehmen. Dies fördert eine tiefe innere Ruhe, reduziert Stress und stärkt Ihre Fähigkeit, auch in stürmischen Zeiten zentriert und handlungsfähig zu bleiben. Es ist ein Weg zu mehr Selbstmitgefühl und bewusster Lebensgestaltung.",
  icon: Feather
}, {
  id: "embodiment",
  title: "Embodiment",
  shortDescription: "Beziehen Sie die Weisheit Ihres Körpers aktiv in den Heilungsprozess ein.",
  fullDescription: "Körper und Geist sind untrennbar miteinander verbunden. Beim Embodiment beziehen wir körperliche Empfindungen, Haltungen und Bewegungen aktiv in die Beratung ein. Indem wir die 'Sprache des Körpers' verstehen lernen, können wir emotionale Blockaden lösen, neue Perspektiven verankern und ein ganzheitliches Wohlbefinden fördern. Veränderungen werden so nicht nur kognitiv verstanden, sondern körperlich spürbar und nachhaltig integriert.",
  icon: Activity
}];
export default function InteractiveCards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="interactivecards" className="py-24 bg-background overflow-hidden">
      
    </section>;
}